import { render, staticRenderFns } from "./ListPlaceOrderResult.vue?vue&type=template&id=b8712892&"
import script from "./ListPlaceOrderResult.vue?vue&type=script&lang=js&"
export * from "./ListPlaceOrderResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports